// extracted by mini-css-extract-plugin
module.exports = {"container":"tagList_container__33HQ6","tag":"tagList_tag__1npMN","removeIcon":"tagList_removeIcon__2J1ZN"};